// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-link-module__textLink--UEN5S8\\+G{color:var(--purpleflat)}.text-link-module__textLink--UEN5S8\\+G.text-link-module__disabled--Dq-6f8qv{color:var(--grey4);cursor:not-allowed}", "",{"version":3,"sources":["webpack://./src/shared/ui/text-link/text-link.module.scss"],"names":[],"mappings":"AAAA,uCACE,uBAAA,CAEA,4EACE,kBAAA,CACA,kBAAA","sourcesContent":[".textLink {\n  color: var(--purpleflat);\n\n  &.disabled {\n    color: var(--grey4);\n    cursor: not-allowed;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textLink": "text-link-module__textLink--UEN5S8+G",
	"disabled": "text-link-module__disabled--Dq-6f8qv"
};
export default ___CSS_LOADER_EXPORT___;
